export default {
  EN: 'en-CA',
};
